import { Outlet, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { Sidebar } from './Sidebar.js';
import { TopBar } from './TopBar.js';
import { useAuth } from '@/lib/auth.js';

/** The persistent layout shell: left rail + top bar + content area. */
export function Shell(): JSX.Element {
  const { status } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'anonymous') void navigate({ to: '/login' });
  }, [status, navigate]);

  if (status !== 'authenticated') {
    return (
      <div className="flex h-screen items-center justify-center bg-background text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
      </div>
    );
  }

  return (
    <div className="grid h-screen grid-cols-[240px_1fr] grid-rows-[56px_1fr] bg-background text-foreground">
      <div className="row-span-2 border-r border-border bg-card">
        <Sidebar />
      </div>
      <div className="border-b border-border bg-card/50 backdrop-blur">
        <TopBar />
      </div>
      <main className="overflow-auto">
        <div className="mx-auto max-w-6xl px-6 py-8 animate-fade-in">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
